import { PERMISSION_GROUPS } from '../constants/PermissionGroups'

export const HK_HOME_PATH = '/main/mln-hk'
export const HK_REPORT_ROOT_PATH = '/main/report-for-hk'
export const HK_REPORT_PATH = `${HK_REPORT_ROOT_PATH}/mtd-performance-report`

export const isCommonUserPath = (pathname: string): boolean =>
  pathname.replace(/\/+$/, '') === '/main/profile/change-password'

export const getPermissionGroups = (profile: unknown): string | undefined => {
  if (
    !profile ||
    typeof profile !== 'object' ||
    !('permissionGroups' in profile)
  ) {
    return undefined
  }
  const permission = (profile as { permissionGroups: unknown }).permissionGroups
  return typeof permission === 'string' && permission.trim()
    ? permission
    : undefined
}

export const isHkPathAllowed = (pathname: string): boolean => {
  const normalized = pathname.replace(/\/+$/, '')
  return (
    normalized === HK_HOME_PATH ||
    normalized === HK_REPORT_ROOT_PATH ||
    normalized === HK_REPORT_PATH ||
    isCommonUserPath(pathname)
  )
}

export const isMlnHk = (permission: string | undefined): boolean =>
  permission === PERMISSION_GROUPS.MLN_HK
